import { login, logout, getInfo, register } from "@/api/user.js";
import { getToken, setToken } from "@/utils/auth.js";
import router from "@/router";
import { Message } from "element-ui";
const state = {
  token: getToken(),
  infoLoading: false,
  avatar: "",
  // 账号
  account: "",
  // 加密密码
  password: "",
  // 显示昵称
  name: "未知",
  // 账号ID
  id: "",
  // 手机
  phone: "",
  // 状态，0正常，1冻结
  status: "",
  // 账号类型：Personal,Enterprise,Expert,Manage
  userType: "",
  // 人员基本信息(个人、专家)
  personalInfo: null,
  // 企业基本信息
  enterpriseInfo: null,
  // 专家基本信息
  expertInfo: null,
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
    setToken(token);
  },
  SET_INFO: (state, info) => {
    if (info) {
      state.account = info.account;
      state.password = info.password;
      state.name = info.name;
      state.id = info.id;
      state.phone = info.phone;
      state.status = info.status;
      state.userType = info.userType;
      state.personalInfo = info.personalInfo;
      state.enterpriseInfo = info.enterpriseInfo;
      state.expertInfo = info.expertInfo;
    } else {
      state.account = "";
      state.password = "";
      state.name = "";
      state.id = "";
      state.phone = "";
      state.status = "";
      state.userType = "";
      state.personalInfo = null;
      state.enterpriseInfo = null;
      state.expertInfo = null;
    }
  },
  SET_INFO_LOADING: (state, loading) => {
    state.infoLoading = loading;
  },
};

const getters = {
  role(state) {
    return state.userType || "";
  },
  isPersonal(state) {
    return state.userType === "Personal";
  },
  isEnterprise(state) {
    return state.userType === "Enterprise";
  },
  isExpert(state) {
    return state.expertInfo;
  },
  personalAudited(state) {
    return state.personalInfo?.auditStatus === "Pass";
  },
  enterpriseAudited(state) {
    return state.enterpriseInfo?.auditStatus === "Pass";
  },
  expertAudited(state) {
    return state.expertInfo?.auditStatus === "Pass";
  },
  audited(state) {
    if (state.userType === "Personal") {
      return state.name ? true : false;
    } else if (state.userType === "Expert") {
      return state.expertInfo?.auditStatus === "Pass";
    } else if (state.userType === "Enterprise") {
      return state.enterpriseInfo?.auditStatus === "Pass";
    } else {
      return false;
    }
  },
};

const actions = {
  // user login
  login({ commit }, params) {
    return new Promise((resolve, reject) => {
      login(params)
        .then(res => {
          if (res.code === 200 && res.success) {
            commit("SET_TOKEN", res.data.token);
            resolve();
          } else {
            var msg = res.message || "系统异常";
            reject(msg);
            Message.error(msg);
          }
        })
        .catch(error => {
          // console.error(error);
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ state, commit }) {
    return new Promise((resolve, reject) => {
      if (state.infoLoading) return;
      commit("SET_INFO_LOADING", true);
      getInfo()
        .then(res => {
          const data = res?.data;
          if (data) {
            commit("SET_INFO", data);
            resolve(data);
          } else {
            commit("SET_INFO", null);
            reject("data is null");
          }
        })
        .catch(error => {
          commit("SET_INFO", null);
          reject(error);
          // console.error(error);
        })
        .finally(() => {
          commit("SET_INFO_LOADING", false);
        });
    });
  },

  // user logout
  logout({ commit }) {
    return new Promise(resolve => {
      logout()
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          commit("SET_TOKEN", "");
          commit("SET_INFO", null);
          router.push({ path: "/", replace: true });
          resolve();
        });
    });
  },

  register({ commit }, params) {
    return new Promise((resolve, reject) => {
      register(params)
        .then(res => {
          resolve();
        })
        .catch(err => {
          console.error(err);
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
